export default __webpack_public_path__ + "static/media/aisthisi-6.ac039179.gif";